import SessionHeartBeat, { ISessionHeartBeatResponse } from "../SessionHeartBeat";

export default class DoSingleSessionHeartBeatUseCase {
  public static async doSingleSessionHeartBeat(sessionHeartBeat: SessionHeartBeat): Promise<ISessionHeartBeatResponse> {
    return await sessionHeartBeat.doSessionHearBeat();
  }
}
